import { FormatUrlParameters } from '@garmin/support-utils';
import { capi } from '../../client';
import ApiConfig from '../../../../config/api';

const getDefaultState = () => ({
  repairFaqId: null,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    repairFaqId: (state) => state.repairFaqId,
    getTextResultsUrlQs: (state, getters, rootState, rootGetters) => (queryParamsObj) => (new URLSearchParams({
      ...FormatUrlParameters.stripFalsyProps(queryParamsObj),
      ct: 'content',
      mr: ApiConfig.textResultsPerPage,
      locale: rootGetters.locale,
      si: 0,
      tags: [ApiConfig.region_repairtab, queryParamsObj.productTag],
    }).toString()),
  },
  mutations: {
    reset(state) {
      Object.assign(state, getDefaultState());
    },
    repairFaqIdUpdate(state, faqId) {
      // eslint-disable-next-line no-param-reassign
      state.repairFaqId = faqId;
    },
  },
  actions: {
    reset({ commit }) {
      commit('reset');
    },
    async fetchRepairResults({ getters, commit, rootGetters }, productTag) {
      const apiId = 'fetchRepairResults';
      if (rootGetters[`isApiIdCallInProgress(${apiId})`]) return;
      commit('incrementApiCallsInProgress', apiId, { root: true });
      commit('repairFaqIdUpdate', null);

      try {
        const params = { ...rootGetters.apiParams };
        params.productTagName = '';

        const locale = params.altLocale || rootGetters.locale;

        const endpointPath = `content/${locale}/?${getters.getTextResultsUrlQs({ ...params, productTag })}`;

        const { data, status } = await capi.get(endpointPath);

        if (data && status === 200) {
          if (!data?.contentDetails) data.contentDetails = [];

          if (data.contentDetails.length === 1) {
            commit('repairFaqIdUpdate', data.contentDetails[0].contentId);
          } else { commit('repairFaqIdUpdate', false); }
        }
      } catch (e) {
        commit('repairFaqIdUpdate', false);
      } finally {
        commit('decrementApiCallsInProgress', apiId, { root: true });
      }
    },
    async repairFaqIdUpdate({ commit }, faqId) {
      commit('repairFaqIdUpdate', faqId);
    },
  },
};
